import axios from '../axiosInstance';

export type TaskResult = {
  state: string;
  data: Record<string, unknown>;
};

export const CommonApi = () => ({
  getTaskStatus: (taskId: string) =>
    axios.get<TaskResult>(`/common/tasks/${taskId}/`)
});
